import "./GridHeader.scss";

import classNames from "classnames";
import React, { ReactNode } from "react";

export interface GridHeaderProps {
  title?: string;
  tooltip?: string;
  entityName?: string;
  name?: string;
  icon?: ReactNode | string;
  className?: string;
  iconOnly?: boolean;
}

export const GridHeader: React.FC<GridHeaderProps> = ({ title, tooltip = "", icon, className, iconOnly = false }) => {
  if (!tooltip && !title) {
    title = "\u00A0";
  }

  if (iconOnly && !tooltip) {
    tooltip = title || "";
  }

  return (
    <th className={className}>
      <span className={classNames("grid-header", tooltip ? "global-tooltip-trigger" : "")} title={tooltip}>
        {icon ? typeof icon === "string" ? <i className={icon} /> : icon : ""}
        {!!title && !iconOnly && <span className="title">{title}</span>}
      </span>
    </th>
  );
};
